<script>
// import wantedPeople from "/data/wantedPersonell.json"

export default {
  name: "SearchPerson",
  data(){
    return{
      searchCriminal:"",

      searchResults:[],
      searching:false,
      startIndex:0,
      emptySearch:[]
    }
  },
  props:{
    allWantedPeople: Array
  },

  methods:{
    searchUser(){
    let userName = this.searchCriminal;
    //Error checking
      if(userName === "") {
        alert("The search Bar is empty");
        return null;
      }
       this.emptySearch = [];
      let returnedNames = this.allWantedPeople.filter((eventData)=>{
        if(userName === "") return eventData
        else if (eventData.name.toLowerCase().includes(userName.toLowerCase())){
          return eventData;

            }
          }

      );

       this.searchResults = returnedNames;
       this.emptySearch = this.getWantedPeople();
       this.startIndex = 0;
      // this.searchCriminal = ""
      this.searching = true

    },

    getWantedPeople(){
      const searchR=[];
      for(let i=this.startIndex; i< this.startIndex +9 && i < this.searchResults.length; i++){
        searchR.push(this.searchResults[i]);
      }
      this.startIndex +=9;
     
      return searchR
    },
    handleScroll(){
      if(window.scrollY + window.innerHeight >= document.body.scrollHeight-50){
        this.emptySearch = [
          ...this.emptySearch, ...this.getWantedPeople()
        ];
      }
    },
    closeSearch(){
      this.searchResults = [];
      this.emptySearch = [];
      this.searching = false
      this.searchCriminal = "";
    },
  },

  mounted() {


    window.addEventListener("scroll",this.handleScroll);
  }

}
</script>

<template>

<div class="search-bar-container">
  <div class="search-bar-wrapper">
    <input class="search-input" type="text" v-model="searchCriminal" placeholder="search">
     <button  @click="searchUser()">Search</button>

  </div>
</div>


  <div class="wanted-people-description-wrap container">

    <div class="row search-results-container-row" v-if="emptySearch.length > 0">
      <p class="search-text">Search Results</p>




      <div class="col-lg-4 col-md-6 searched-wanted-people-card" v-for="(wantedPerson,i) in emptySearch" :key="i">
        <div class="wanted-people-card-wrapper  ">
          <div class="wanted-people-card-img">
            <img :src="`https://www.saps.gov.za/crimestop/wanted/${wantedPerson.image}`" :alt="wantedPerson.name">
          </div>
          <div class="wanted-people-card-description">



            <div class="wanted-people-names">
              <span class="span-title">Name:</span>
              <span class="span-description"> {{wantedPerson.name}} </span>
            </div>
            <div class="wanted-people-card-crime-details">
              <span class="span-title">Crime:</span>
              <span class="span-description" >{{wantedPerson.crime}}</span>

            </div>
            <div class="wanted-people-card-crime-details">
              <span class="span-title">Status:</span>
              <span class="span-description" >{{wantedPerson.status}}</span>

            </div>

            <div class="wanted-people-card-button">
              <a class="wanted-people-card-more-details-btn" :href="`https://www.saps.gov.za/crimestop/wanted/${wantedPerson.link}`">More Details</a>
            </div>

          </div>
        </div>

      </div>
      <button class="close-btn" @click="closeSearch()">Close</button>
      </div>

       <div v-if="searching && emptySearch.length === 0">
          <div class="alert alert-danger" role="alert">
          No results found

        </div>

   </div>



  </div>

</template>

<style scoped>
.search-bar-wrapper button{
  background-color: white;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  border-color: white;
  font-family: 'montserrat', sans-serif;
}
.search-input{
  border-top-left-radius: 5px ;
  border-bottom-left-radius: 5px ;
  font-family: 'montserrat', sans-serif;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border-color: white;


}
.search-text{
  color: white;
}
.search-results-container-row{
  background-color: rgba(83, 125, 223, 0.78);
  border-radius: 2px;
  padding-bottom: 10px;

}
.wanted-people-wrapper{
  padding: 5px;
}

.sort-by-container{
  padding-top: 40px;

}

.sort-by-container select{
  padding: 5px;
  font-family: 'montserrat', sans-serif;
}

.wanted-people-description-wrap{
  padding-top: 40px;
}

.wanted-people-card-wrapper{
  background-color: rgba(223, 41, 53, 0.39);
  padding: 15px;
  max-width: 250px;
  border-radius: 3px;
  max-height:800px ;
  margin:0 auto 20px auto;
  text-align: left;


}
.wanted-people-card-img img{
  width: 200px;
  height: 200px;
  max-width: 200px;
  color: white;
  font-weight: lighter;
}
.wanted-people-names{
  padding: 5px 0 5px 0;
  max-width: 10px;
}

.wanted-people-card-description span{
  color:white;
}



.span-title{
  padding: 0 2px 0 0;
  font-weight: bold;
}

.wanted-people-card-crime-details{
  padding: 0 0 5px 0;
}
.wanted-people-card-button{
  padding: 5px 0 0 0 ;
  text-align: center;

}
.wanted-people-card-more-details-btn{
  background-color: #00A7E1;
  text-decoration: none;
  padding: 3px 3px 3px 3px;
  border-radius: 3px;
  width: 95%;
  display: block;

}

.close-btn{
  background-color: white;
}


</style>
